import React, { Component, useState } from "react";
import TagManager from 'react-gtm-module'
import { App_input, Img, BtnSubmit } from "../UI/UI";
import {
  handleInputChange,
  regxValidation,
  simpleValidation,
} from "../../Utility/Utility";
import Http from "../../Axios/Axios.js";
 
class Form extends Component {
  clickRedirect = () => {
    // alert("gsbfgb");
    const val1 = document.querySelector("#text_1").value;
    const val2 = document.querySelector("#email_1").value;
    const this_form = document.querySelector("form");
    if (val1 && val2) {
      console.log("sent");

   
      this_form.submit();
      TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generate_lead', 'element_location':'lead_form',}});
      window.location.replace("https://agents.israel.travel/thank-you.html");
 
    } else {
      alert('full name and  email are required');
    }
  }; 
  render() {
    return (
      <div class="form-view">
        <div class="panel panel-default">
          <div class="panel-body">
            <div class="form-container">
              <div id="messages"></div>
              <form
                action="https://crud.activated.digital/app/app/f?id=20"
                method="post"
                enctype="multipart/form-data"
                accept-charset="UTF-8"
                id="form-app"
                className="form-flex"
              >
                <div className="ac-col ac-col-1">
                  <div class="form-group">
                    <input
                      type="text"
                      id="text_1"
                      name="text_1"
                      //   value={this.state.fullname}
                      data-alias=""
                      placeholder="Full Name (required)"
                      class="form-control"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <input
                      type="email"
                      id="email_1"
                      name="email_1"
                      //   value={this.state.email}
                      data-alias=""
                      placeholder="Email (required)"
                      class="form-control"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <input
                      type="text"
                      id="text_5"
                      name="text_5"
                      //   value={this.state.company}
                      data-alias=""
                      placeholder="Company Name"
                      class="form-control"
                    />
                  </div>
                </div>
                <div className="ac-col ac-col-2">
                  <div class="form-group">
                    <input
                      type="text"
                      id="text_2"
                      name="text_2"
                      //   value={this.state.estate}
                      data-alias=""
                      placeholder="State"
                      class="form-control"
                    />
                  </div>
                  <div className="ac-inner-col">
                    <div className="ac-subinner-col ac-subinner-col-1">
                      <div class="form-group">
                        <input
                          type="text"
                          id="text_3"
                          name="text_3"
                          //   value={this.state.city}
                          data-alias=""
                          placeholder="City"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div className="ac-subinner-col ac-subinner-col-2">
                      <div class="form-group">
                        <input
                          type="text"
                          id="text_4"
                          name="text_4"
                          //   value={this.state.zip}
                          data-alias=""
                          placeholder="Zip Code"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  {/* <BtnSubmit
            type="submit"
            cssClass="ac-send"
            onClick={this.handleSubmit}
          >
            <div className="ac-cont">
              <span>SUBMIT</span>
              <Img desktopImg="arrowwright.svg" mobileImg="arrowwright.svg" />
            </div>
          </BtnSubmit> */}
                  <button
                    type="submit"
                    id="button_1"
                    name="button_1"
                    class="ac-send"
                    onClick={this.clickRedirect}
                  >
                    <div className="ac-cont">
                      <span>SUBMIT</span>
                      <Img
                        desktopImg="arrowwright.svg"
                        mobileImg="arrowwright.svg"
                      />
                    </div>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/Components/Form/Form.js